module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_8017.4705f491.png";